/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface BrandFormWarningsData
 */
export interface BrandFormWarningsData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BrandFormWarningsData
     */
    label?: ValidationMessage;
}

export function BrandFormWarningsDataFromJSON(json: any): BrandFormWarningsData {
    return BrandFormWarningsDataFromJSONTyped(json, false);
}

export function BrandFormWarningsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandFormWarningsData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': !exists(json, 'label') ? undefined : ValidationMessageFromJSON(json['label']),
    };
}

export function BrandFormWarningsDataToJSON(value?: BrandFormWarningsData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': ValidationMessageToJSON(value.label),
    };
}


